import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=5c7c9ce0&scoped=true&"
import script from "./Icons.vue?vue&type=script&lang=js&"
export * from "./Icons.vue?vue&type=script&lang=js&"
import style0 from "./Icons.vue?vue&type=style&index=0&id=5c7c9ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7c9ce0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7c9ce0')) {
      api.createRecord('5c7c9ce0', component.options)
    } else {
      api.reload('5c7c9ce0', component.options)
    }
    module.hot.accept("./Icons.vue?vue&type=template&id=5c7c9ce0&scoped=true&", function () {
      api.rerender('5c7c9ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Icons.vue"
export default component.exports